"use client";

import { AspectRatioPicture } from "@faire/retailer-visitor-shared/components/Image/AspectRatioPicture";
import { SDUIImage } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Image/SDUIImage";
import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import { getCssFromStyle } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/getCssFromTileStyle";
import { SDUITileInstanceRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";

const IMAGE_WIDTH = 220;

export const SDUIBrandTileWithActionRenderer = ({
  tileElement,
  loggingData,
  renderBehaviour,
}: SDUITileInstanceRendererProps) => {
  const { on_click, style } = tileElement;
  const { brand, button } = tileElement.brand_tile_with_action ?? {};

  return (
    <Column
      className="items-center justify-between"
      style={getCssFromStyle(style)}
    >
      <SDUIOnClickHandler
        onClickActions={on_click}
        loggingData={loggingData}
        className="contents"
        logLegacyClickEvent
      >
        <AspectRatioPicture $ratio={1} $width="100%">
          <SDUIImage
            renderBehaviour={renderBehaviour}
            responsiveImage={{
              mobileAndAbove: brand?.image ?? IImage.build({}),
            }}
            optimizeImageOptions={{
              width: IMAGE_WIDTH,
            }}
            isProductImage
          />
        </AspectRatioPicture>
        <Typography
          truncate
          variant="paragraphSansMedium"
          className="w-full p-4! text-center"
        >
          {brand?.name}
        </Typography>
      </SDUIOnClickHandler>
      {button ? (
        <SDUIButtonRenderer
          buttonElement={button}
          loggingData={loggingData}
          className="mb-4! w-4/5!"
        />
      ) : null}
    </Column>
  );
};
